import { createStore, withProps } from '@ngneat/elf';
import { FundingDtoError, PpmMilestone, PpmMilestoneDto, RefParams, SlotDtoError } from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';
import { refParamsInitialState } from '@/store/ref-param-state/ref-param-state.store';

export interface PpmMilestoneProps {
  milestone: PpmMilestone;
  milestoneDto: PpmMilestoneDto;
  initialMilestoneDto: PpmMilestoneDto;
  serviceIdSelected: SelectOption;
  typeOfMarketIdSelected: SelectOption;
  selectionModeIdSelected: SelectOption;
  errors?: Record<string, string[]>;
  slotErrors?: SlotDtoError[];
  fundingErrors?: FundingDtoError[];
}

export const initialMilestoneDto: PpmMilestoneDto = {
  id: 0,
  realisationEnvisagees: '',
  'service.id': undefined,
  beneficiaire: undefined,
  'typeMarcher.id': undefined,
  'modePassation.id': 0,
  budgetEstime: undefined,
  datePrevAc: new Date(),
  datePrevDp: new Date(),
  datePrevAp: new Date(),
  datePrevLps: new Date(),
  lots: [],
  financements: [],
  realisationFiles: [],
  docIds: [],
};

export const ppmMilestonesInitialState: PpmMilestoneProps = {
  milestone: {
    id: 0,
    version: 0,
    realisationEnvisagees: '',
    beneficiaire: '',
    service: structuredClone(refParamsInitialState.response) as RefParams,
    typeMarcher: structuredClone(refParamsInitialState.response) as RefParams,
    modePassation: structuredClone(refParamsInitialState.response) as RefParams,
    budgetEstime: undefined,
    datePrevLps: new Date().toISOString(),
    datePrevAc: new Date().toISOString(),
    datePrevDp: new Date().toISOString(),
    datePrevAp: new Date().toISOString(),
    isPublished: false,
    publishedAt: new Date().toISOString(),
    lots: [],
    financements: [],
    docs: [],
    usedInDac: false,
  },
  milestoneDto: structuredClone(initialMilestoneDto),
  initialMilestoneDto: structuredClone(initialMilestoneDto),
  serviceIdSelected: { name: '', code: 0 },
  typeOfMarketIdSelected: { name: '', code: 0 },
  selectionModeIdSelected: { name: '', code: 0 },
  slotErrors: [],
  fundingErrors: [],
};

export const ppmMilestonesStoreFactory = (id: string) => {
  return createStore({ name: `ppm-milestones-${id}` }, withProps<PpmMilestoneProps>(structuredClone(ppmMilestonesInitialState)));
};
